// 全局变量定义
/**
 * ROLE_*：账号角色
 * 0-普通用户, 1-超级管理员 / 2-管理员 / 3-客服 / 4-稿件处理员 / 5-质控编辑 / 6-编辑 / 7-网站编辑 / 8-财务;
 *
 * PAPER_STATUS_*：稿件状态
 * 1-已提交 / 2-已报价 / 3-待处理 / 4-已付款 / 5-处理中 / 6-编辑中 / 7-编辑完成 / 8-质控中 / 9-已完成
 *
 * TASK_STATUS_*：任务状态
 * 已分配(编辑)-1, 已拒绝-2, 编辑中-3, 编辑完成-4, 已分配(质控)-5, 已拒绝(质控)-6, 质控中-7, 质控完成-8, 已完成-9
 *
 * PAY_TYPE_*： 支付方式
 * 0-余额 / 1-微信 / 2-支付宝 / 3-银联 / 4-联系客服支付
 *
 * REFUND_STATUS*：退款状态
 * 0-客服发起退款空记录 / 1-用户提交退款信息 / 2-客服流转退款申请后 / 3-财务完成退款后
 */
export default {

  ROLE_0: 0,
  ROLE_1: 1,
  ROLE_2: 2,
  ROLE_3: 3,
  ROLE_4: 4,
  ROLE_5: 5,
  ROLE_6: 6,
  ROLE_7: 7,
  ROLE_8: 8,

  PAPER_STATUS_1: 1,
  PAPER_STATUS_2: 2,
  PAPER_STATUS_3: 3,
  PAPER_STATUS_4: 4,
  PAPER_STATUS_5: 5,
  PAPER_STATUS_6: 6,
  PAPER_STATUS_7: 7,
  PAPER_STATUS_8: 8,
  PAPER_STATUS_9: 9,

  TASK_STATUS_1: 1,
  TASK_STATUS_2: 2,
  TASK_STATUS_3: 3,
  TASK_STATUS_4: 4,
  TASK_STATUS_5: 5,
  TASK_STATUS_6: 6,
  TASK_STATUS_7: 7,
  TASK_STATUS_8: 8,
  TASK_STATUS_9: 9,

  PAY_TYPE_0: 0,
  PAY_TYPE_1: 1,
  PAY_TYPE_2: 2,
  PAY_TYPE_3: 3,
  PAY_TYPE_4: 4,

  REFUND_STATUS_0: 0,
  REFUND_STATUS_1: 1,
  REFUND_STATUS_2: 2,
  REFUND_STATUS_3: 3
}



// WEBPACK FOOTER //
// ./src/utils/global.js